import { writable } from 'svelte/store';

/**
 * @type {import('svelte/store').Writable<Object<string, any> | undefined>}
 */
export const userStore = writable();
